import { Box, Typography, Container } from "@mui/material";
import { useTranslation } from "react-i18next";

// Custom hooks
import Instruction from "./UI/Instruction";
import RedirectButton from "./UI/RedirectButton";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

//Participant Documents
import ParticipantDocDE from "../../assets/Download Participant Documents/Participant_Documents_DE.docx.pdf";
import ParticipantDocEN from "../../assets/Download Participant Documents/Participant_Documents_EN.docx.pdf";

// Stadistics Component

import VideoStatistics from "./VideoStatistics/VideoStatistics";
import { useScheduler } from "../../hooks/useScheduler";

export default function StartSite({
  setContent,
  setIsTourOpen,
  OpenVideoDialog,
}) {
  const { t } = useTranslation();
  const { name } = useScheduler();

  function handleStartTour() {
    setContent("schedule");
    setTimeout(() => {
      setIsTourOpen(true);
    }, 1000);
  }

  const openPdf = (e) => {
    let pdfUrl;
    if (e === "EN") {
      pdfUrl = ParticipantDocEN;
    } else {
      pdfUrl = ParticipantDocDE;
    }
    window.open(pdfUrl, "_blank"); // Opens in new tab
  };

  return (
    <Container
      sx={{
        height: "85vh",
        background: "white",
        py: "70px",
        overflow: "auto",
        borderRadius: "16px",
        position: "relative",
        color: "#000038",
      }}
    >
      <Box sx={{ marginTop: "20px" }}>
        <Typography
          variant="h3"
          sx={{
            textAlign: "center",
            fontWeight: "bold",
          }}
        >
          Desk Dynamics – {t("coursehomepage")}
        </Typography>
      </Box>
      <Box>
        <Instruction title={t("Welcome, {{name}}", { name: name })}>
          <VideoStatistics />
          <span style={{ fontWeight: "bold" }}>Desk Dynamics</span>{" "}
          {t("digitalPreventionCourse")}
        </Instruction>

        <Instruction title={t("targetgroup")}>
          <ul>
            <li>{t("sedentaryJobs")}</li>
            <li>{t("suitableforbeginners")}</li>
          </ul>
        </Instruction>
        <Instruction title={t("howthecourseworks")}>
          <ul>
            <li>
              <Typography sx={{ fontWeight: "bold" }} variant="span">
                {t("exercisereminders")}
              </Typography>{" "}
              {t("howthecourseworksText")}
            </li>
            <li>
              <Typography sx={{ fontWeight: "bold" }} variant="span">
                {t("posturememories")}
              </Typography>{" "}
              {t("posturememoriesText")}
            </li>
            <li>
              <Typography sx={{ fontWeight: "bold" }} variant="span">
                {" "}
                {t("calendarView")}
              </Typography>{" "}
              {t("calendarViewText")}
            </li>
            <li>
              <Typography sx={{ fontWeight: "bold" }} variant="span">
                {t("videoLibrary")}:
              </Typography>{" "}
              {t("videoLibraryText")}
            </li>
          </ul>
        </Instruction>
        <Instruction title={t("intensityofuse")} text={t("intensityofuseText")}>
          <ul>
            <li>{t("intensityofuse1")}</li>
            <li>{t("intensityofuse2")}</li>
          </ul>
        </Instruction>
        <Instruction title={t("coreObjectives")}>
          <ul>
            <li>
              <Typography sx={{ fontWeight: "bold" }} variant="span">
                {t("coreObjectives1")}{" "}
              </Typography>
              {t("coreObjectivesText1")}
            </li>
            <li>
              <Typography sx={{ fontWeight: "bold" }} variant="span">
                {t("coreObjectives2")}{" "}
              </Typography>
              {t("coreObjectivesText2")}
            </li>
            <li>
              <Typography sx={{ fontWeight: "bold" }} variant="span">
                {t("coreObjectives3")}{" "}
              </Typography>
              {t("coreObjectivesText3")}
            </li>
            <li>
              <Typography sx={{ fontWeight: "bold" }} variant="span">
                {t("coreObjectives4")}{" "}
              </Typography>
              {t("coreObjectivesText4")}
            </li>
          </ul>
        </Instruction>
        <Instruction title={t("TransferEveryday")}>
          <ul>
            <li>
              <Typography sx={{ fontWeight: "bold" }} variant="span">
                {t("TransferEveryday1")}
              </Typography>{" "}
              {t("TransferEverydayText1")}
            </li>
            <li>
              <Typography sx={{ fontWeight: "bold" }} variant="span">
                {t("TransferEveryday2")}
              </Typography>{" "}
              {t("TransferEverydayText2")}
            </li>
            <li>
              <Typography sx={{ fontWeight: "bold" }} variant="span">
                {t("TransferEveryday3")}
              </Typography>{" "}
              {t("TransferEverydayText3")}
            </li>
          </ul>
        </Instruction>
        <Instruction
          title={t("Contraindications")}
          text={t("ContraindicationsText")}
        ></Instruction>
        <Instruction title={t("StudyEvidence")}>
          <ul>
            <li>{t("StudyEvidence1")}</li>
            <li>
              <a
                href="https://osf.io/qzspm"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("StudyEvidence2")}
              </a>
            </li>
            <li>{t("StudyEvidence3")}</li>
          </ul>
        </Instruction>
        <Instruction title={t("DataProtection")}>
          <ul>
            <li>{t("DataProtection1")}</li>
            <li>
              <Typography sx={{ fontWeight: "bold" }} variant="span">
                {t("pseudonymized")}
              </Typography>
              {t("DataProtection2")}
            </li>
            <li>{t("DataProtection3")}</li>
          </ul>
        </Instruction>
        <Instruction title="FAQs" text={t("FAQs")}>
          <ul>
            <li>
              <a
                href={`${process.env.REACT_APP_FIREBASE_BASE_URL}/help-faq`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("ToFAQs")}
              </a>
            </li>
          </ul>
        </Instruction>
        <Instruction
          title={t("ParticipantDocuments")}
          text={t("ParticipantDocumentsText")}
        >
          <ul>
            <Typography sx={{ my: "6px", fontWeight: "bold" }}>
              {t("DownloadParticipationDocuments")}
            </Typography>
            <li>
              English{" "}
              <OpenInNewIcon
                sx={{ cursor: "pointer" }}
                onClick={() => openPdf("EN")}
              />
            </li>
            <li>
              Deutsch{" "}
              <OpenInNewIcon
                sx={{ cursor: "pointer" }}
                onClick={() => openPdf("DE")}
              />
            </li>
          </ul>
        </Instruction>
        <Instruction title={t("Support")} text={t("SupportText")}>
          <ul sx={{ gap: "20px" }}>
            <li>
              {t("Support1")}{" "}
              <OpenInNewIcon
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  setContent("feedback");
                }}
              />{" "}
            </li>
            <li>
              {t("Suppor2")}{" "}
              <OpenInNewIcon
                sx={{ cursor: "pointer" }}
                onClick={() => OpenVideoDialog()}
              />
            </li>
            <li>
              {t("Support3")}{" "}
              <OpenInNewIcon
                sx={{ cursor: "pointer" }}
                onClick={handleStartTour}
              />{" "}
            </li>
          </ul>
        </Instruction>
        <Instruction title={t("Accessibility")} text={t("AccessibilityText")}>
          <ul>
            <li>{t("Accessibility1")}</li>
            <li>{t("Accessibility2")}</li>
            <li>{t("Accessibility3")}</li>
          </ul>
        </Instruction>
        <Instruction
          title={t("FurtherHealthInfo")}
          text={t("FurtherHealthInfoText")}
        >
          <ul>
            <a
              href={`${process.env.REACT_APP_FIREBASE_BASE_URL}/preventive_course-info`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("FurtherHealthInfo")}
            </a>
          </ul>
        </Instruction>
        <Instruction title={t("Getstarted")}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <RedirectButton
              setContent={setContent}
              content="schedule"
              label={t("Configurenow")}
              text={t("setReminders")}
            />
            <RedirectButton
              setContent={setContent}
              content="library"
              label={t("Viewexercises")}
              text={t("openLibrary")}
            />
          </Box>
        </Instruction>
      </Box>
    </Container>
  );
}
